function typographyColors() {
  const clrs = {
    action_text: '#f5f5f5',
    range_text: '#f5f5f5',
    combo_text: '#121212',
    range_active: '#1e1e1e',
    range_empty: '#1e1e1e',
    combo_range_active: '#cfcfcf',
    combo_range_empty: '#1e1e1e',
  }
  return clrs
}

function otherColors() {
  const clrs = {
    range: '#ff8f00',
    eveqeqrbl: '#F03C3C',
    eveqeqrbl_2: '#FFA83D',
    eveqeqrbl_3: '#59D167',
  }
  return clrs
}

function trainerTableColors() {
  const clrs = {
    trainer_active_canvas_back: '#141414',
    trainer_active_canvas_outline: '#1EC39C00',
    trainer_active_table_back: '#00000000',
    trainer_active_table_outline: '#4D4D4D',
    trainer_canvas_back: '#121212',
    trainer_canvas_outline: '#00000000',
    trainer_table_back: '#00000000',
    trainer_table_outline: '#262626',
    trainer_player_hero: '#00ac8d',
    trainer_player_opponent: '#ff8f00',
    trainer_player_active: '#3f3f3f',
    trainer_player_folded: '#262626',
    trainer_pattern: '#1e1e1e8F',
    trainer_hand_highlight: '#ffb800',
    trainer_action_btn_default_background: '#1e1e1e',
  }
  return clrs
}

function actionsColors() {
  const clrs = {
    C: '#5ab966',
    X: '#5ab966',
    F: '#3D7CB8',
    R_default: '#F03C3C',
    R1: '#f03c3c',
    R1_2: '#dd3737',
    R2: '#ca3232',
    R2_2: '#b62e2e',
    R3: '#a32929',
    R3_2: '#902424',
    R4: '#7d1f1f',
    R4_2: '#6a1a1a',
  }
  return clrs
}

function suitsColors() {
  const clrs = {
    diamonds: '#2235C5',
    spades: '#504F4F',
    clubs: '#0EAD2C',
    hearts: '#AD0E04',
    card_back: '#2f2f2f',
  }
  return clrs
}

function ipOopColors() {
  const clrs = {
    player_oop: '#97EAF8',
    player_ip: '#25B336',
  }
  return clrs
}

function defaultStyles() {
  const res = {
    cardTheme: 'default_big_symbol',
    cardBack: 'back_logo',
    styleEqBuckets: 'two', // one, two
    traineBackPattern: 'none',
    actionBtnShadowStyle: 'shadow_drop',
    rangeCellShadowStyle: 'shadow_drop',
  }
  return res
}

// apiMiscDict - remeber to add this to apiDicts.js
function defaultMics() {
  const res = {
    showBetsIn: 'bb',

    showEvIn: 'ev', // aka. show_ev_in aka. sw_ev_converter
    showEvIcmIn: 'csd', // aka. show_ev_icm_in aka. sw_ev_icm_converter
    // this is obviously bad to use 3 names for one thing
    // but to use single name we would have to refactor how settings work (with maintaining back compatibility)
    // and merge it with how switchers work - so for now we are stuck with these 3 names
    // one for /settings, one for userSetting store and one for switchers store
    // it would be a ton of renamig stuff all over the place to do this

    showHandValue: true,
    showSolutionsDialog: true,
    showLoadingTips: true,
    showLegacySolutions: false,
    keepFiltersBetweenSpots: true,
    gmfStacksTableAsGrid: true,
    gmfKeepHistory: true,
    switchersDefaults: { sw_actions_grouping: 'swv_grouping_none' },
    soundVolume: 1,
    solfigrDashboard: 'seg_untracked', // v1, v2 (seg_untracked)
  }

  return res
}

function defaultHeroTableSeats() {
  // horizontal, vertical
  const res = {
    _2: [1, 1],
    _3: [1, 1],
    _4: [2, 2],
    _5: [4, 4],
    _6: [5, 5],
    _7: [6, 0],
    _8: [0, 0],
    _9: [0, 0],
    _10: [0, 0],
  }
  return res
}

function defaultDashboardLinks() {
  const res = [
    'StudySolutions',
    'PracticeTrainer',
    'AnalyzeFilesV4',
    'StudyCustomSolutions',
    'PracticeRangeBuilder',
    'AnalyzeHandsV3',
    'Coaching',
    'PracticeDrills',
    'external_HelpCenter',
  ]
  return res
}

function defaultTablesColumns() {
  const res = {
    hhhandsv2: [
      'result',
      'date_played',
      'status',
      'site',
      'format',
      'pot_type',
      'hero_position',
      'hand',
      'board',
      'gto_score',
      'total_ev_loss',
      'total_ev_loss_as_pot',
      'total_frequency_difference',
      'total_pot',
      'amount_won',
      'actions',
      'label',
    ],
    hhhandsv1: [
      'date_played',
      'status',
      'site',
      'format',
      'ev_mistake',
      'amount_won',
      'total_pot',
      'hero',
      'hand',
      'board',
      'actions',
    ],
    practicehands: [
      'created_at',
      'result',
      'format',
      'shortcut_type',
      'hero_position',
      'hand',
      'board',
      'gto_score',
      'total_ev_loss',
      'total_ev_loss_as_pot',
      'total_frequency_difference',
      'actions',
    ],
    practicesessions: [
      'created_at',
      'format',
      'name',
      'hands',
      'gto_score',
      'ev_loss',
      'ev_loss_avg',
    ],
    uploadedfiles: [
      'date',
      'status',
      'name',
      'total_hands',
      'analyzed_hands',
      'correct',
      'mistakes',
      'avg_ev_mistake',
    ],
    savedspots: [
      'format', //
      'board',
      'actions',
      'note',
      'tags',
    ],
  }
  return res
}

function defaultTours() {
  return {
    gameformat: 'not_finished',
    help: 'help',
    StudySolutions: 'not_finished',
    PracticeTrainer: 'not_finished',
    PracticeRangeBuilder: 'component_triggered', // -- triggered from 2nd step in builder
    NodelockDialog: 'component_triggered', // -- triggered from dialog
    NodecompareDialog: 'component_triggered', // -- triggered from dialog
  }
}

export {
  typographyColors,
  otherColors,
  trainerTableColors,
  actionsColors,
  suitsColors,
  ipOopColors,
  defaultStyles,
  defaultMics,
  defaultHeroTableSeats,
  defaultDashboardLinks,
  defaultTablesColumns,
  defaultTours,
}
